module.exports = __webpack_public_path__ + "f166cdcdb7e729f32e350ccd51a5b357.png";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/prize_3.png
// module id = 202
// module chunks = 0